export const helpCenterLandingPageRoute = '/h';
export const helpCenterContactPageRoute = (translatedContactSlug: string) =>
  `/h/${translatedContactSlug}`;
